// import {useSelector} from "react-redux";
import { Navigate, Outlet } from 'react-router-dom';
const PrivateWorkerRoute = () => {
  // const {userToken } = useSelector( state => state.authReducer );

  const userToken = localStorage.getItem('workerToken');
  return userToken ? <Outlet /> : <Navigate to="/login" />;
};
export default PrivateWorkerRoute;
